import { useCallback } from "react";

import { fireLeadSubmitEvents } from "goi_common";

import { postLeadV2, PostLeadV2Body } from "@/apis/postLeadV2";

/**
 * v2 통합 리드 제출 진입점. HTTP(postLeadV2)와 집계 이벤트(fireLeadSubmitEvents)를 조립한다.
 *
 * 리드 폼은 이 훅을 쓴다. `postLeadV2` 를 직접 부르면 lead_submit 집계가 빠진다.
 * `scripts/check-lead-submit-event.mjs` 가 직접 호출을 검사한다.
 * platform 의 같은 훅과 내용이 같다 (앱별 Axios 인스턴스가 달라 공용화 불가).
 */
export const useSubmitLead = () => {
  /** 호출부 useCallback deps 에 넣어도 재생성되지 않도록 참조를 고정한다. */
  const submitLead = useCallback(async (body: PostLeadV2Body) => {
    const data = await postLeadV2(body);
    fireLeadSubmitEvents(body.lead_type, body.status);
    return data;
  }, []);

  return { submitLead };
};
